import { useQuery } from '@tanstack/react-query';

import { tokenRequests } from '../api/api';
import { OnlineBookingErrors } from '../api/errors';
import cacheQueryKeys from '../resources/queryCacheKeys';
import { statusCodesMapper } from '../utils/exception';

type Props = {
  token: string;
};

export const useOrgData = ({ token }: Props) => {
  const useQueryResponse = useQuery({
    queryKey: [cacheQueryKeys.PublicOrgData],
    queryFn: async () => {
      const response = await tokenRequests.fetchOrgData(token);

      return statusCodesMapper(response, {
        [OnlineBookingErrors.orgNotFound]: () => {
          throw new Error(OnlineBookingErrors.orgNotFound);
        },
        unhandled: () => {
          throw new Error();
        },
      });
    },
    staleTime: 30 * 60 * 1000,
  });

  const { data } = useQueryResponse;

  return {
    ...useQueryResponse,
    isUnscheduled: Boolean(data && 'bookingPreferences' in data && data?.bookingPreferences?.bookAsUnscheduled),
  };
};
